import React, {useEffect} from 'react';
import Header from "../components/Header";

function Sütitájékoztató() {
    document.title= "Sütikezelési tájékoztató"

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return <div className={"content sutikezelesi-tajekoztato"}>
        <h1>Sütikezelési tájékoztató</h1>
        <p>Ez a weboldal sütiket („cookie-kat”) használ a felhasználói élmény javítása és a látogatottság elemzése érdekében.</p>
        <h3>Mik azok a sütik?</h3>
        <p>A sütik kis szöveges fájlok, amelyeket a böngésző tárol el a felhasználó eszközén. Segítségükkel a weboldal felismeri a látogatót, és információkat tud gyűjteni a böngészési szokásokról.</p>
        <h3>Milyen sütiket használunk?</h3>
        <p>A weboldal kizárólag a Google Analytics által használt sütiket alkalmazza. Ezek a sütik abban segítenek, hogy megértsük, hogyan használják a látogatók az oldalt (pl. melyik aloldalakat keresik fel, mennyi időt töltenek a weboldalon).</p>
        <br/>
        <p>Az így gyűjtött adatok anonimizáltak, személyes azonosításra nem alkalmasak.</p>
        <h3>Hogyan kezelhetők a sütik?</h3>
        <p>Az oldal megnyitásával egy felugró üzenetben tájékoztatjuk a felhasználót a sütik használatáról, mely során lehetőség van a sütik elfogadására, illetve elutasítására. Fontos megjegyezni, hogy ezeket a beállításokat bármikor módosíthatjuk.</p>
        <h3>Hozzájárulás</h3>
        <p>A felugró ablakban az "Elfogadás" gomb megnyomásával a felhasználó hozzájárul a sütik alkalmazásához.</p>
    </div>
}

export default Sütitájékoztató;